import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import AdvertiserSearch from './AdvertiserSearch';
import OrdersGrid from '../containers/OrdersGrid';
import Spinner from './Spinner';
import ErrorPage from '../errors/ErrorPage';

const styles = ( /* theme */ )=> ({
  root: {
    padding: 20
  },
  allowOverflow: {
    overflow: 'visible',
    padding: 20
  }
});

class AdvertiserPage extends Component {

  state = {
    pollTimer: null,
    amount: 0
  };

  onSelect = (selectedData) => {
    let amount = selectedData.reduce((accumulator, current) => {
      return accumulator + parseFloat(current.totalAmount);
    }, 0);
    this.setState({ amount: amount });
  }

  render() {
    const {
      classes,
      onChange,
      isFetching,
      advertisers,
      selectedAdvertiser,
      isFetchingAdvertisers,
      isReadOnly,
      error: apiError
    } = this.props;

    const error = apiError || (isFetching || !isEmpty(selectedAdvertiser) ? null : { status: 404 });

    return (
      <div className={classes.root}>
        <ErrorPage error={error} entity="advertiser">
          <Grid container spacing={0}>
            <Grid item xs={12}>
              {isFetchingAdvertisers && <Spinner />}
              {!isFetchingAdvertisers && advertisers && (
              <Card className={classes.allowOverflow}>
                <AdvertiserSearch
                  advertisers={advertisers}
                  selectedAdvertiser={selectedAdvertiser}
                  onChange={onChange}
                />
              </Card>
              )}
            </Grid>
            <Grid item xs={12}>
              {isFetching && <Spinner />}
              {!isFetching && selectedAdvertiser && (
              <Card>
                <OrdersGrid
                    orders={selectedAdvertiser.Ios}
                    selectedAmount={this.state.amount}
                    onSelect={this.onSelect}
                    isReadOnly={isReadOnly}
                />
              </Card>
              )}
            </Grid>
          </Grid>
        </ErrorPage>
      </div>
    )
  }
}

AdvertiserPage.propTypes = {
  advertisers: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};

export default withStyles(styles)(AdvertiserPage);

